/* global filter_obj, URLSearchParams, history */
jQuery(document).ready(function($) {

    /************* Case Study Filter - START *****************/
    const $form = $('#case-study-ajax-filter form.listing-filter-form');

    $form.on('submit', function(event) {
        event.preventDefault();

        $('.lg-filter-selected-list').empty();

        // Collect capability
        const capability = $form.find('input[name="capability"]:checked').map(function() {
            const label = $(this).closest('li').find('label').data('label');

            $('.lg-filter-selected-list').append(
                '<span class="lg-selected capability-selected" data-slug="capability_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );

            return this.value;
        }).get().join(',');

        // Collect market
        const market = $form.find('input[name="market"]:checked').map(function() {
            const label = $(this).closest('li').find('label').data('label');

            $('.lg-filter-selected-list').append('<span class="lg-selected market-selected" data-slug="market_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>');

            return this.value;
        }).get().join(',');

        const pager = $form.find('#pager').val();
        const posts_per_page = $form.find('input[name="posts_per_page"]').val();
        const search_text = $form.find('input[name="search_text"]').val();
        const lg_select_capability = $form.find('input[name="cslg_by_capability"]').val();
        const lg_select_market = $form.find('input[name="cslg_by_market"]').val();
        const sort_value = $form.find('.filter-order').val();

        modify_casestudy_filter_url(pager, search_text, sort_value, capability, market);

        casestudy_filter_data(
            pager,
            posts_per_page,
            search_text,
            sort_value,
            capability,
            lg_select_capability,
            market,
            lg_select_market,
        );
    });
    /************* Case Study Filter - END *****************/

    // Reset pager on search
    $(document).on('input', '#case-study-ajax-filter .search-text', function() {
        $form.find('#pager').val(1);
    });

    // Trigger search
    $(document).on('click', '#case-study-ajax-filter .icon-search', function(e) {
        e.preventDefault();
        $form.find('#pager').val(1);
        $form.submit();
    });

    // Remove selected filter
    $(document).on('click', '.lg-filter-selected-list .lg-selected', function() {
        const fid = $(this).data('slug');
        $('#' + fid).prop('checked', false);
        $(this).remove();

        $form.find('#pager').val(1);
        $form.submit();
    });

    // Dropdown / checkbox change
    $form.on('change', '.cat-filter, .filter-order', function() {
        $form.find('#pager').val(1);
        $form.submit();
    });

    // Reset Filter
    $(document).on('click', '.filter-reset', function(e) {
        e.preventDefault();

        $form.find('input[type="checkbox"]').prop('checked', false);
        $form.find('input[type="text"], input[type="search"]').val('');
        $form.find('select').prop('selectedIndex', 0);

        $('.lg-filter-selected-list').empty();

        $form.find('#pager').val(1);
        $form.submit();

        const current_page_url = $form.find('input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);
    });

    /**
     * AJAX Call
     */
    function casestudy_filter_data(
        pager,
        posts_per_page,
        search_text,
        sort_value,
        capability,
        lg_select_capability,
        market,
        lg_select_market,
    ) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: filter_obj.ajax_url,
            data: {
                action: 'fetch_casestudy_list',
                security: filter_obj.nonce,
                pager: pager,
                posts_per_page: posts_per_page,
                search_text: search_text,
                capability: capability,
                lg_select_capability: lg_select_capability,
                market: market,
                lg_select_market: lg_select_market,
                sort_value: sort_value,
            },
            beforeSend: function() {
                $form.find('.filter-load-more').show();
                $form.find('.pagination, .lg-grid-main-row').hide();
            },
            success: function(response) {

                $form.find('.filter-load-more').hide();
                $form.find('.lg-grid-main-row').html(response.data).fadeIn();
                $form.find('.pagination').show();
                $form.find('.pagination').html(response.pagination);

                if (response.total_pages) {
                    $form.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $form.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $form.find('.showing-result').text(response.showing);
                }

                const currentPageUrl = $form.find('input[name="current_page_url"]').val();

                $form.find('.pagination a.page-numbers:not(.prev,.next)').each(function() {
                    const pageNumber = parseInt($(this).text());
                    $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
                });

                $form.find('.pagination a.page-numbers.prev:not(.disabled)').each(function() {
                    const previousPage = response.pager - 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
                });

                $form.find('.pagination a.page-numbers.next:not(.disabled)').each(function() {
                    const nextPage = parseInt(response.pager, 10) + 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
                });
            },
            error: function(xhr, status, error) {
                // console.error('AJAX Error:', status, error);
            },
        });
    }

    /**
     * Update URL
     */
    function modify_casestudy_filter_url(pager, search_text, sort_value, capability, market) {

        const current_page_url = $form.find('input[name="current_page_url"]').val();
        const params = new URLSearchParams();

        params.set('pager', pager);

        if (capability) { params.set('capability', capability); }
        if (market) { params.set('market', market); }
        if (search_text) { params.set('search_text', search_text); }
        if (sort_value) { params.set('filter_order', sort_value); }

        const updated_url = current_page_url + '?' + params.toString();

        history.pushState(null, null, updated_url);
    }

    /************* Insight Filter - START *****************/

    const $insightForm = $('#insights-ajax-filter form.listing-filter-form');

    $insightForm.on('submit', function(event) {
        event.preventDefault();

        $('#insights-ajax-filter .lg-filter-selected-list').empty();

        // Collect capability
        const capability = $insightForm.find('input[name="capability"]:checked').map(function() {
            const label = $(this).closest('li').find('label').data('label');

            $('#insights-ajax-filter .lg-filter-selected-list').append(
                '<span class="lg-selected capability-selected" data-slug="capability_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );

            return this.value;
        }).get().join(',');

        // Collect market
        const market = $insightForm.find('input[name="market"]:checked').map(function() {
            const label = $(this).closest('li').find('label').data('label');

            $('#insights-ajax-filter .lg-filter-selected-list').append(
                '<span class="lg-selected market-selected" data-slug="market_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );

            return this.value;
        }).get().join(',');

        // Collect asset type
        const asset_type = $insightForm.find('input[name="asset_type"]:checked').map(function() {
            const label = $(this).closest('li').find('label').data('label');

            $('#insights-ajax-filter .lg-filter-selected-list').append(
                '<span class="lg-selected asset_type-selected" data-slug="asset_type_' + $(this).val() + '"><em class="close-icon"></em>' + label + '</span>',
            );

            return this.value;
        }).get().join(',');

        const pager = $insightForm.find('#pager').val();
        const posts_per_page = $insightForm.find('input[name="posts_per_page"]').val();
        const search_text = $insightForm.find('input[name="search_text"]').val();
        const ilg_by_capability = $insightForm.find('input[name="ilg_by_capability"]').val();
        const ilg_by_market = $insightForm.find('input[name="ilg_by_market"]').val();
        const ilg_asset_type = $insightForm.find('input[name="ilg_asset_type"]').val();
        const sort_value = $insightForm.find('.filter-order').val();

        const hasSearch = search_text.trim().length > 0;
        const hasFilter = $('.cat-filter:checked').length > 0;

        $('#insights-ajax-filter .lg-filter-reset').toggle(hasSearch || hasFilter);

        modify_insight_filter_url(pager, search_text, sort_value, capability, asset_type, market);

        insight_filter_data(
            pager,
            posts_per_page,
            search_text,
            sort_value,
            capability,
            ilg_by_capability,
            asset_type,
            ilg_asset_type,
            market,
            ilg_by_market,

        );
    });


    // Reset pager on search
    $(document).on('input', '#insights-ajax-filter .search-text', function() {
        $insightForm.find('#pager').val(1);

        const hasSearch = $(this).val().trim().length > 0;

        // Show reset if search has value OR filters checked
        const hasFilter = $('.cat-filter:checked').length > 0;

        $('#insights-ajax-filter .lg-filter-reset').toggle(hasSearch || hasFilter);
    });

    // Trigger search
    $(document).on('click', '#insights-ajax-filter .icon-search', function(e) {
        e.preventDefault();

        $insightForm.find('#pager').val(1);

        const searchVal = $insightForm.find('input[name="search_text"]').val().trim();

        if (searchVal.length > 0) {
            $('#insights-ajax-filter .lg-filter-reset').show();
        }

        $insightForm.submit();
    });

    // Remove selected filter
    $(document).on('click', '#insights-ajax-filter .lg-filter-selected-list .lg-selected', function() {
        const fid = $(this).data('slug');
        $('#' + fid).prop('checked', false);
        $(this).remove();

        // Check if any filters are still selected
        const hasFilter = $('.cat-filter:checked').length > 0;

        // Toggle reset button
        $('#insights-ajax-filter .lg-filter-reset').toggle(hasFilter);


        $insightForm.find('#pager').val(1);
        $insightForm.submit();
    });

    // Dropdown / checkbox change
    $insightForm.on('change', '.cat-filter, .filter-order', function() {
        $insightForm.find('#pager').val(1);

        if ($('.cat-filter:checked').length > 0) {
            $('.lg-filter-reset').show();
        } else {
            $('.lg-filter-reset').hide();
        }


        $insightForm.submit();
    });

    // Reset Filter
    $(document).on('click', '.filter-reset', function(e) {
        e.preventDefault();

        $insightForm.find('input[type="checkbox"]').prop('checked', false);
        $insightForm.find('input[type="text"], input[type="search"]').val('');
        $insightForm.find('select').prop('selectedIndex', 0);

        $('.lg-filter-selected-list').empty();

        $insightForm.find('#pager').val(1);
        $insightForm.submit();

        const current_page_url = $insightForm.find('input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);
        $insightForm.find('.lg-filter-reset').hide();
    });

    /**
     * AJAX Call
     */
    function insight_filter_data(
        pager,
        posts_per_page,
        search_text,
        sort_value,
        capability,
        ilg_by_capability,
        asset_type,
        ilg_asset_type,
        market,
        ilg_by_market,
    ) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: filter_obj.ajax_url,
            data: {
                action: 'fetch_insight_list',
                security: filter_obj.nonce,
                pager: pager,
                posts_per_page: posts_per_page,
                search_text: search_text,
                capability: capability,
                ilg_by_capability: ilg_by_capability,
                asset_type: asset_type,
                ilg_asset_type: ilg_asset_type,
                market: market,
                ilg_by_market: ilg_by_market,
                sort_value: sort_value,
            },
            beforeSend: function() {
                $insightForm.find('.filter-load-more').show();
                $insightForm.find('.pagination, .lg-grid-main-row').hide();
            },
            success: function(response) {

                $insightForm.find('.filter-load-more').hide();
                $insightForm.find('.lg-grid-main-row').html(response.data).fadeIn();
                $insightForm.find('.pagination').show();
                $insightForm.find('.pagination').html(response.pagination);

                if (response.total_pages) {
                    $insightForm.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $insightForm.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $insightForm.find('.showing-result').text(response.showing);
                }

                const currentPageUrl = $insightForm.find('input[name="current_page_url"]').val();

                $insightForm.find('.pagination a.page-numbers:not(.prev,.next)').each(function() {
                    const pageNumber = parseInt($(this).text());
                    $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
                });

                $insightForm.find('.pagination a.page-numbers.prev:not(.disabled)').each(function() {
                    const previousPage = response.pager - 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
                });

                $insightForm.find('.pagination a.page-numbers.next:not(.disabled)').each(function() {
                    const nextPage = parseInt(response.pager, 10) + 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
                });
            },
            error: function(xhr, status, error) {
                // console.error('AJAX Error:', status, error);
            },
        });
    }

    /**
     * Update URL
     */
    function modify_insight_filter_url(pager, search_text, sort_value, capability, asset_type, market) {

        const current_page_url = $insightForm.find('input[name="current_page_url"]').val();
        const params = new URLSearchParams();

        params.set('pager', pager);

        if (capability) { params.set('capability', capability); }
        if (asset_type) { params.set('asset_type', asset_type); }
        if (market) { params.set('market', market); }
        if (search_text) { params.set('search_text', search_text); }
        if (sort_value) { params.set('filter_order', sort_value); }

        const updated_url = current_page_url + '?' + params.toString();

        history.pushState(null, null, updated_url);
    }

    /************* Insight Filter - END *****************/

    /************* Insight Filter - START *****************/

    const $newsroomForm = $('#newsroom-ajax-filter form.listing-filter-form');

    $newsroomForm.on('submit', function(event) {
        event.preventDefault();

        const pager = $newsroomForm.find('#pager').val();
        const posts_per_page = $newsroomForm.find('input[name="posts_per_page"]').val();
        const search_text = $newsroomForm.find('input[name="search_text"]').val();
        const newsroom_asset_type = $newsroomForm.find('input[name="newsroom_asset_type"]:checked').val() || 'all';
        const ilg_by_newsroom_asset_type = $insightForm.find('input[name="ilg_by_newsroom_asset_type"]').val();
        const sort_value = $newsroomForm.find('.filter-order').val();
        const nlg_show_asset_date = $newsroomForm.find('#nlg_show_asset_date').val() || '0';
        toggleResetButton();
        modify_newsroom_filter_url(pager, search_text, sort_value, newsroom_asset_type);

        newsroom_filter_data(pager, posts_per_page, search_text, sort_value, newsroom_asset_type, ilg_by_newsroom_asset_type, nlg_show_asset_date);
    });


    // Reset pager on search
    $(document).on('input', '#newsroom-ajax-filter .search-text', function() {
        $newsroomForm.find('#pager').val(1);
        toggleResetButton();
    });

    // Trigger search
    $(document).on('click', '#newsroom-ajax-filter .icon-search', function(e) {
        e.preventDefault();
        $newsroomForm.find('#pager').val(1);
        toggleResetButton();
        $newsroomForm.submit();
    });

    // Dropdown / checkbox change
    $newsroomForm.on('change', '.cat-filter, .filter-order', function() {
        $newsroomForm.find('#pager').val(1);
        toggleResetButton();
        $newsroomForm.submit();
    });

    // Reset Filter
    $(document).on('click', '.reset-filter', function(e) {
        e.preventDefault();

        // Reset all filters
        $newsroomForm.find('input[type="checkbox"]').prop('checked', false);
        $newsroomForm.find('input[type="radio"]').prop('checked', false);

        // Activate "All" tab
        $newsroomForm.find('input[name="newsroom_asset_type"][value="all"]').prop('checked', true);

        // Reset search & dropdown
        $newsroomForm.find('input[type="text"], input[type="search"]').val('');
        $newsroomForm.find('select').prop('selectedIndex', 0);

        $newsroomForm.find('#pager').val(1);
        $newsroomForm.submit();

        const current_page_url = $newsroomForm.find('input[name="current_page_url"]').val();
        history.pushState(null, null, current_page_url);

        // Hide reset button
        $('.filter-reset').fadeOut();
    });

    /**
     * AJAX Call
     */
    function newsroom_filter_data(pager, posts_per_page, search_text, sort_value, newsroom_asset_type, ilg_by_newsroom_asset_type, nlg_show_asset_date) {
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: filter_obj.ajax_url,
            data: {
                action: 'fetch_newsroom_list',
                security: filter_obj.nonce,
                pager: pager,
                posts_per_page: posts_per_page,
                search_text: search_text,
                newsroom_asset_type: newsroom_asset_type,
                ilg_by_newsroom_asset_type: ilg_by_newsroom_asset_type,
                sort_value: sort_value,
                nlg_show_asset_date: nlg_show_asset_date,
            },
            beforeSend: function() {
                $newsroomForm.find('.filter-load-more').show();
                $newsroomForm.find('.pagination, .lg-grid-main-row').hide();
            },
            success: function(response) {

                $newsroomForm.find('.filter-load-more').hide();
                $newsroomForm.find('.lg-grid-main-row').html(response.data).fadeIn();
                $newsroomForm.find('.pagination').show();
                $newsroomForm.find('.pagination').html(response.pagination);

                if (response.total_pages) {
                    $newsroomForm.find('input[name="max_pages"]').val(response.total_pages);
                }

                if (response.pager) {
                    $newsroomForm.find('#pager').val(response.pager);
                }

                if (response.showing) {
                    $newsroomForm.find('.showing-result').text(response.showing);
                }

                const currentPageUrl = $newsroomForm.find('input[name="current_page_url"]').val();

                $newsroomForm.find('.pagination a.page-numbers:not(.prev,.next)').each(function() {
                    const pageNumber = parseInt($(this).text());
                    $(this).attr('href', currentPageUrl + '?pager=' + pageNumber);
                });

                $newsroomForm.find('.pagination a.page-numbers.prev:not(.disabled)').each(function() {
                    const previousPage = response.pager - 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + previousPage);
                });

                $newsroomForm.find('.pagination a.page-numbers.next:not(.disabled)').each(function() {
                    const nextPage = parseInt(response.pager, 10) + 1;
                    $(this).attr('href', currentPageUrl + '?pager=' + nextPage);
                });
            },
            error: function(xhr, status, error) {
                // console.error('AJAX Error:', status, error);
            },
        });
    }

    /**
     * Update URL
     */
    function modify_newsroom_filter_url(pager, search_text, sort_value, newsroom_asset_type) {

        const current_page_url = $newsroomForm.find('input[name="current_page_url"]').val();
        const params = new URLSearchParams();

        params.set('pager', pager);

        if (newsroom_asset_type) { params.set('newsroom_asset_type', newsroom_asset_type); }
        if (search_text) { params.set('search_text', search_text); }
        if (sort_value) { params.set('filter_order', sort_value); }

        const updated_url = current_page_url + '?' + params.toString();

        history.pushState(null, null, updated_url);
    }

    function toggleResetButton() {
        const hasSearch = $newsroomForm.find('input[name="search_text"]').val().trim().length > 0;
        const hasFilter = $newsroomForm.find('.cat-filter:checked').length > 0;

        if (hasSearch || hasFilter) {
            $('.filter-reset').fadeIn();   // smoother UI
        } else {
            $('.filter-reset').fadeOut();
        }
    }
    /************* Insight Filter - END *****************/

});